import React from 'react';
import Icon from '../../../components/AppIcon';

const ColorSwatch = ({ color, isSelected, onSelect, disabled }) => {
  return (
    <button
      onClick={() => !disabled && onSelect(color)}
      disabled={disabled}
      className={`
        relative w-full aspect-square rounded-lg overflow-hidden transition-all duration-300
        border-2 hover:scale-105
        ${isSelected ? 'border-primary shadow-lg' : 'border-border'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      `}
    >
      <div
        className="w-full h-full"
        style={{ backgroundColor: color?.hex }}
      />
      {isSelected && (
        <div className="absolute inset-0 bg-background/20 flex items-center justify-center">
          <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <Icon name="Check" size={18} color="white" />
          </div>
        </div>
      )}
      <div className="absolute bottom-0 left-0 right-0 bg-background/90 backdrop-blur-sm p-2">
        <p className="text-xs font-medium text-text-primary truncate">
          {color?.name}
        </p>
      </div>
    </button>
  );
};

export default ColorSwatch;